import react, { useRef, useState } from "react"
import { connect } from 'react-redux'
import { fetchOffers } from '../../actions'
import NextIcon from '../../images/next.svg'
import PrevIcon from '../../images/previous.svg'
import '../../style/offers.css'
const Offers = (props) => {
    const outerSilder = useRef()
    const innerSlider = useRef()
    // const sliderItemWidth = useRef()
    const [sliderItemWidth,setSliderItemWidth] = useState(270)
    const innerSliderWidth = useRef(0)
    const currentTranslation = useRef(0)
    const sliderLeftIcon = useRef() 
    const sliderRightIcon = useRef()

    
    react.useEffect(() => {
        props.fetchOffers()

    }, [])

    react.useEffect(() => {
        setSliderItemWidth(outerSilder.current.offsetWidth / 4 - 10)
        innerSliderWidth.current = sliderItemWidth * props.offers.data.length + 10
        // innerSliderWidth.current = sliderItemWidth * props.offers.data.length
       

    }, [])
    
    const sliderScrollLeft = () => {
        currentTranslation.current -= innerSliderWidth.current / props.offers.data.length    
        innerSlider.current.style.transform = `translateX(${currentTranslation.current}px)`
        const scrollable = innerSliderWidth.current / props.offers.data.length * (props.offers.data.length - 4)
        if (currentTranslation.current <= (-scrollable)){
            innerSlider.current.style.transform = `translateX(-${scrollable}px)`
            currentTranslation.current = (-scrollable)
            // sliderLeftIcon.current.style.display = "none"

        }

        
    }
    const sliderScrollRight = () => {
        currentTranslation.current += innerSliderWidth.current / props.offers.data.length
        innerSlider.current.style.transform = `translateX(${currentTranslation.current}px)`
        if (currentTranslation.current > 0){
            innerSlider.current.style.transform = `translateX(0px)`
            currentTranslation.current = 0
            // sliderRightIcon.current.style.display = "none"

        }


        
    }

    const renderOffers = props.offers.data.map(x => {

        return (
                
                <div className="offer-item" key={x.id} style={{width: props.mobileNav ? "240px" : sliderItemWidth + "px" || "240px"}}>
                    <div className="name">{x.code}</div>
                    <p className="discount">{`Get ${x.discount}% discount`}</p>
                </div>
        )
    })
    const renderSliderControler = () => {
        if (!props.mobileNav){
            return (    <>
                        {/* <LeftCircleOutlined style={{position: "absolute", fontSize: '40px', zIndex: "100", color: '#FF385C', background: 'White', borderRadius: '50%', cursor: 'pointer', padding: '4px', left: '0', top: '46%'}} onClick={sliderScrollLeft} /> */}
                        <img src={PrevIcon} className="slider-handle-left"  width={35} alt="left icon" onClick={sliderScrollLeft} ref={sliderLeftIcon}/>
                        <img src={NextIcon} className="slider-handle-right" alt="right Icon" width={35} onClick={sliderScrollRight} ref={sliderRightIcon}/>
                        </>
                    )
        }
        return null
    }
    innerSliderWidth.current = (sliderItemWidth * props.offers.data.length) + (props.offers.data.length * 10) 
    const innerSliderStyle = props.mobileNav ? {width: '100%'} : {transform: 'translateX(0px)' ,transition: 'all 0.4s', width: innerSliderWidth.current}
    return(
        <div className="offer-slider-container">
        <div className="offer-outer-container max-width containerAF">
            <h2 className="offer-title">Best Offers</h2>
            {renderSliderControler()}
            <div className="offer-inner-container" ref={outerSilder}>
                <div className="offer-scroll-container" ref={innerSlider} style={innerSliderStyle}>
                    {renderOffers}
                </div>
            </div>
            {/* <RightCircleOutlined style={{position: "absolute", fontSize: '30px', zIndex: "100"}}/> */}
        </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        offers: state.couponOffers,
        mobileNav: state.mobileNav
    }
}
export default connect(mapStateToProps, { fetchOffers })(Offers);